// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__NNRtX","header":"ReportDetails_header__2GeH-","title":"ReportDetails_title__1XoA5","left":"ReportDetails_left__1rowU"};